import React, { Component } from 'react';
import { Navbar, Nav, NavItem} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './customNav.css';
class CustomNav extends Component {
    render() {
        return (
            <Navbar default collapseOnSelect>
                <Navbar.Header>
                    <Navbar.Brand>
                        <Link to="/">Joy Zhang</Link>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav pullRight>
                        <NavItem eventKey={1} componentClass={Link} href="/" to="/">
                        Home
                        </NavItem>
                        <NavItem eventKey={2} componentClass={Link} href="/about" to="/about">
                        About
                        </NavItem>
                        <NavItem eventKey={3} href="https://medium.com/@joy8zhang">
                        Blog
                        </NavItem>
                        <NavItem eventKey={4} href={require('./assets/JoyZhang_Resume.pdf')}>
                        Resume
                        </NavItem>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

export default CustomNav;



// WEBPACK FOOTER //
// ./src/components/customNav.js